'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (password) {
	var warningCodes = [];

	// check empty
	if (!password || !password.trim()) {
		warningCodes.push('_IS_NULL');
	}
	// length check
	var minLength = 8;
	if (password.length < minLength) {
		warningCodes.push('_TOO_SHORT');
	}
	var maxLength = 20;
	if (password.length > maxLength) {
		warningCodes.push('_TOO_LONG');
	}
	// repeated sequence
	var disallowedRepetition = /(.)\1{3}/g;
	if (password.match(disallowedRepetition)) {
		warningCodes.push('_CONTAINS_REPEATED_CHARACTERS');
	}
	// consecutive Number
	var disallowedNumberPatterns = /0123|1234|2345|3456|4567|5678|6789|7890|8901|9012/g;
	if (password.match(disallowedNumberPatterns)) {
		warningCodes.push('_CONTAINS_NUMBER_SEQUENCE');
	}
	// sequence Character
	var disallowedSequences = /qwer|wert|erty|rtyu|tyui|yuio|uiop|asdf|sdfg|dfgh|fghj|ghjk|hjkl|zxcv|xcvb|cvbn|vbnm|QWER|WERT|ERTY|RTYU|TYUI|YUIO|UIOP|ASDF|SDFG|DFGH|FGHJ|GHJK|HJKL|ZXCV|XCVB|CVBN|VBNM/g;
	if (password.match(disallowedSequences)) {
		warningCodes.push('_CONTAINS_LETTER_SEQUENCE');
	}
	// sequence Special Characters
	var disallowedCharacters = /\`123|890-|90-=|iop[|op[]|p\[\]\\|jkl\;|kl\;'|bnm,|nm,.|m,.\/|~!@\#|!@\#$|@#\$%|#\$%\^|\$%\^&|\%\^&\*|\^&\*\(|&\*\(\)|\*\(\)\_|\(\)\_\+|iop\[|op\[\]|p\[\]\\|BNM<|NM<>|M<>\?|IOP{}|OP{}|P{}\|/g;
	if (password.match(disallowedCharacters)) {
		warningCodes.push('_CONTAINS_NUMBER_LETTER_SEQUENCE');
	}
	// blacklisted password
	var blacklisted_passwords = ['password', 'access14', 'americanidol', 'baseball', 'baseball1', 'bigdaddy', 'blink182', 'butthead', 'cocacola', 'computer', 'corvette', 'cowboys', 'danielle', 'dolphins', 'einstein', 'firebird', 'football', 'football1', 'iloveyou', 'iloveyou1', 'internet', 'jennifer', 'jordan23', 'liverpool', 'liverpool1', 'marlboro', 'maverick', 'melanie', 'michelle', 'midnight', 'mistress', 'mountain', 'myspace1', 'password', 'password1', 'princess1', 'qwertyui', 'redwings', 'rush2112', 'samantha', 'scorpion', 'slipknot1', 'srinivas', 'startrek', 'starwars', 'sunshine', 'superman', 'superman1', 'swimming', 'trustno1', 'victoria', 'whatever', 'passwort', 'passwort1', 'frankfurt', 'fussball'];
	if (blacklisted_passwords.includes(password.toLowerCase())) {
		warningCodes.push('_IS_BLACKLISTED');
	}
	// contains spaces
	if (/\s/.test(password)) {
		warningCodes.push('_CONTAINS_SPACES');
	}
	// has illegal chars & allow only 7-bit printable chars
	if (password.split('').some(function (char) {
		return char.charCodeAt(0) < 32 || char.charCodeAt(0) > 126;
	})) {
		warningCodes.push('_HAS_ILLEGAL_CHARACTERS');
	}

	return warningCodes;
};

module.exports = exports['default']; /*
                                     	This validation was pulled from https://github.paypal.com/ConsumerWeb-R/consonbdnodeweb/blob/develop/lib/validator.js#L143
                                     	and was converted from OOP to a more simplistic functional structure with ES6 flare.
                                      */


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/util/passwordValidator.js
// module id = 409
// module chunks = 6